import { render, staticRenderFns } from "./RmcRegistrationTile.vue?vue&type=template&id=9673fec0&scoped=true&"
import script from "./RmcRegistrationTile.vue?vue&type=script&lang=js&"
export * from "./RmcRegistrationTile.vue?vue&type=script&lang=js&"
import style0 from "./RmcRegistrationTile.vue?vue&type=style&index=0&id=9673fec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9673fec0",
  null
  
)

export default component.exports